import React, { useState, useEffect, useContext } from "react";
import { useLocation, Link, useNavigate } from "react-router-dom";
import * as Md from "react-icons/md";
import Logo from "../../Assets/logo-home.png";
import * as Ai from "react-icons/ai";
import * as Bs from "react-icons/bs";
import * as Bi from "react-icons/bi";
import * as Ri from "react-icons/ri";
import * as Fa6 from "react-icons/fa6";
import { TbUserHexagon } from "react-icons/tb";

import { jwtDecode } from "jwt-decode";

import "./Header.css";
import { AppContext } from "../../Context/AppContext";
function Header() {
  const location = useLocation();
  const navigate = useNavigate();
  const { deleteCookieData, cookieData } = useContext(AppContext);
  const [isUrl, setIsUrl] = useState(null);
  const [sidebar, setSidebar] = useState(false);
  const [isSuperadmin, setIsSuperadmin] = useState(false);

  useEffect(() => {
    if (cookieData && cookieData.length != 0) {
      const tokenData = jwtDecode(cookieData);
      setIsSuperadmin(tokenData?.role === "superadmin" ? true : false);
    }
  }, [cookieData]);

  useEffect(() => {
    setIsUrl(location.pathname);
  }, [location]);

  const handleLogout = async () => {
    await deleteCookieData({
      onLogoutSuccess: () => {
        setTimeout(() => {
          navigate("/login");
        }, 1000);
      },
    });
  };

  return (
    <div className="container-fluid backgrd">
      <div className="container-fluid">
        {location.pathname != "/profile" && (
          <button
            type="button"
            className="profile_btn"
            onClick={() => navigate("/profile")}
          >
            <i>
              <TbUserHexagon />
            </i>{" "}
            <span>Profile</span>
          </button>
        )}
        <button
          type="button"
          className="nav_btn"
          onClick={() => setSidebar(!sidebar)}
        >
          <i>{!sidebar ? <Bi.BiMenuAltLeft /> : <Ri.RiCloseLine />}</i>
        </button>
      </div>
      <div className={`side-bar ${!sidebar ? "hide" : "show"}`}>
        <div className="text-center">
          <img src={Logo} alt="" className="logo-svg" />
        </div>
        <div className="text-center head">
          <b>Trusted Payer</b>
        </div>
        <div className="text-center">
          <h6 className="menu mb-3">Menu</h6>
        </div>
        <ul>
          <li className={"links " + (isUrl === "/" ? "active" : "")}>
            <Link to="/" className="nav-links">
              <i>
                <Md.MdOutlineSpaceDashboard />
              </i>
              Dashboard
            </Link>
            <p className={"tooltip_ " + (isUrl === "/" ? "active" : "")}>
              Dashboard
            </p>
          </li>

          <li
            className={
              "links " + (isUrl === "/businessprofile" ? "active" : "")
            }
          >
            <Link to="/businessprofile" className="nav-links">
              <i>
                <Bs.BsBuilding />
              </i>
              Companies
            </Link>
            <span
              className={
                "tooltip_ " + (isUrl === "/businessprofile" ? "active" : "")
              }
            >
              Companies
            </span>
          </li>
          <li
            className={
              "links " + (isUrl === "/businesscategory" ? "active" : "")
            }
          >
            <Link to="/businesscategory" className="nav-links">
              <i>
                <Md.MdOutlineCategory />
              </i>
              Business Categories
            </Link>
            <span
              className={
                "tooltip_ " + (isUrl === "/businesscategory" ? "active" : "")
              }
            >
              Business Categories
            </span>
          </li>
          <li
            className={
              "links " + (isUrl === "/complaint-category" ? "active" : "")
            }
          >
            <Link to="/complaint-category" className="nav-links">
              <i>
                <Fa6.FaRegStarHalfStroke />
              </i>
              Review Rating
            </Link>
            <span
              className={
                "tooltip_ " + (isUrl === "/complaint-category" ? "active" : "")
              }
            >
              Review Rating
            </span>
          </li>
          <li className={"links " + (isUrl === "/users" ? "active" : "")}>
            <Link to="/users" className="nav-links">
              <i>
                <Bi.BiUserCircle />
              </i>
              Users
            </Link>
            <span
              className={
                "tooltip_ " +
                (isUrl === "/users"
                  ? "active"
                  : "/viewuser/:id"
                  ? "active"
                  : "")
              }
            >
              Users
            </span>
          </li>
          <li className={"links " + (isUrl === "/complaints" ? "active" : "")}>
            <Link to="/complaints" className="nav-links">
              <i>
                <Ai.AiOutlineMail />
              </i>
              Reviews
            </Link>
            <span
              className={
                "tooltip_ " + (isUrl === "/complaints" ? "active" : "")
              }
            >
              Reviews
            </span>
          </li>
          {isSuperadmin && (
            <li className={"links " + (isUrl === "/admins" ? "active" : "")}>
              <Link to="/admins" className="nav-links">
                <i>
                  <Md.MdOutlineAdminPanelSettings />
                </i>
                Admins
              </Link>
              <span
                className={"tooltip_ " + (isUrl === "/admins" ? "active" : "")}
              >
                Admins
              </span>
            </li>
          )}
          <li className={"links " + (isUrl === "/settings" ? "active" : "")}>
            <Link to="/settings" className="nav-links">
              <i>
                <Ai.AiFillSetting />
              </i>
              Settings
            </Link>
            <span
              className={"tooltip_ " + (isUrl === "/settings" ? "active" : "")}
            >
              Settings
            </span>
          </li>
        </ul>
        <div className="footered">
          <button className="log" onClick={handleLogout}>
            <Ai.AiOutlinePoweroff />
            <span className="ps-3">Logout</span>
          </button>
        </div>
      </div>
    </div>
  );
}

export default Header;
